import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { AgGridReact } from 'ag-grid-react';
import { LicenseManager } from 'ag-grid-enterprise';
import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-balham.css';
import { getLocaleText } from 'utils/localization/agGridLocale';

LicenseManager.setLicenseKey(`${AG_GRID_LICENSE}`);

const gridOpts = {
  defaultColDef: {
    enableRowGroup: true,
    enablePivot: true,
    sortable: true,
    resizable: true,
    filter: 'agTextColumnFilter',
  },
  groupDefaultExpanded: 2,
  rowDragManaged: true,
  rowSelection: 'multiple',
  copyHeadersToClipboard: true,
  suppressColumnVirtualisation: true,
  suppressScrollOnNewData: true,
};

export default class CargomaticGrid extends Component {
  static defaultProps = {
    groupDefaultExpanded: gridOpts.groupDefaultExpanded,
    rowSelection: gridOpts.rowSelection,
    overlayLoadingMessage: 'Loading Rows...',
  };

  static propTypes = {
    columnDefs: PropTypes.array,
    defaultColDef: PropTypes.object,
    frameworkComponents: PropTypes.object,
    gridStyles: PropTypes.object,
    groupDefaultExpanded: PropTypes.number,
    handleRowSelection: PropTypes.func,
    onGridReady: PropTypes.func,
    rowData: PropTypes.array,
    rowSelection: PropTypes.string,
    overlayLoadingMessage: PropTypes.string,
  };

  constructor(props) {
    super(props);

    this.state = {
      statusBar: {
        statusPanels: [{ statusPanel: 'agAggregationComponent' }],
      },
    };
  }

  getOverlayTemplate = () => {
    return `<span class="ag-overlay-loading-center">${this.props.overlayLoadingMessage}</span>`;
  };

  getRowNodeId = (data) => {
    return data.docId || data._id;
  };

  render() {
    const {
      columnDefs,
      defaultColDef,
      frameworkComponents,
      gridStyles,
      groupDefaultExpanded,
      handleRowSelection,
      onGridReady,
      rowData,
      rowSelection,
    } = this.props;

    const defaultStyles = {
      height: '700px',
      width: '1200px',
      ...gridStyles,
    };

    const defaultColumnDefs = Object.assign(
      {},
      gridOpts.defaultColDef,
      defaultColDef,
    );

    return (
      <div className="ag-theme-balham mt-2" style={defaultStyles}>
        <AgGridReact
          floatingFilter
          rememberGroupStateWhenNewData
          enableRangeSelection
          deltaRowDataMode
          rowData={rowData}
          rowSelection={rowSelection}
          getRowNodeId={this.getRowNodeId}
          frameworkComponents={frameworkComponents}
          multiSortKey="ctrl"
          onGridReady={onGridReady}
          statusBar={this.state.statusBar}
          columnDefs={columnDefs}
          defaultColDef={defaultColumnDefs}
          groupDefaultExpanded={groupDefaultExpanded}
          onRowSelected={handleRowSelection}
          overlayLoadingTemplate={this.getOverlayTemplate()}
          localeText={getLocaleText()}
        />
      </div>
    );
  }
}
